import { render, staticRenderFns } from "./ExploitationCardComponent.vue?vue&type=template&id=1fffae95"
import script from "./ExploitationCardComponent.vue?vue&type=script&lang=js"
export * from "./ExploitationCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports